<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>
					<i class="el-icon-lx-cascades"></i> 用户列表
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<div class="handle-box">
				<el-select v-model="value" placeholder="请选择" @change='changeUser'>
					<el-option v-for="item in options" :key="item.value" :label="item.Name" :value="item.Id">
					</el-option>
				</el-select>
				<el-input placeholder="姓名" class="handle-input mr10" v-model="personName" clearable></el-input>
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
				<el-button type="primary" icon="el-icon-circle-plus-outline" @click="createPerson">创建系统用户</el-button>
			</div>
			<el-table :data="personList" border class="table" ref="multipleTable" header-cell-class-name="table-header"
				style="width: 100%">
				<el-table-column prop="Name" label="姓名" align="center" min-width="150"></el-table-column>
				<el-table-column prop="State" label="状态" width="90" align="center">
					<template #default="scope">
						<div v-for="(item) in userState" :key="item">
							<el-tag v-if="scope.row.State==item.value" :type="scope.row.State==1?'success':'danger'">
								{{item.name}}
							</el-tag>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="RoleName" label="角色名称" align="center" min-width="200"></el-table-column>
				<el-table-column prop="Phone" label="手机号" align="center" min-width="150"></el-table-column>
				<el-table-column fixed="right" label="操作" width="200" align="center">
					<template #default="scope">
						<el-button @click="handleClick(scope.row)" type="text">查看</el-button>
						<el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">编辑
						</el-button>
						<el-button @click="stop(scope.row)" type="text" v-if="scope.row.State == 1?true:false"
							icon="el-icon-circle-close" style="color: red;">停用
						</el-button>
						<el-button @click="start(scope.row)" type="text" v-if="scope.row.State == 0?true:false"
							icon="el-icon-circle-check" style="color: green;">启用
						</el-button>
						<!-- <el-button type="text" icon="el-icon-delete" @click="deleteUser(scope.row)" style="color: red;">
							删除</el-button> -->
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination background layout="total, prev, pager, next" :current-page="pageIndex"
					:page-size="pageSize" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
			</div>

			<!-- 编辑弹出框 查看弹出框-->
			<el-dialog :title="title" v-model="editVisible" width="30%">
				<el-form label-width="100px" ref="ruleForm" :model="ruleForm" :rules="rules">
					<el-form-item label="姓名" prop="Name">
						<el-input v-model="ruleForm.Name" :disabled="isdisabled"></el-input>
					</el-form-item>
					<el-form-item label="角色名称" prop="RoleId">
						<el-select v-model="ruleForm.RoleId" placeholder="请选择角色" style="width: 100%;"
							:disabled="isdisabled" clearable>
							<el-option :label="item.Name" :value="item.Id" v-for="item in options" :key="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="手机号" prop="Phone">
						<el-input v-model="ruleForm.Phone" :disabled="isdisabled" maxlength="11"></el-input>
					</el-form-item>
					<el-form-item label="密码" prop="PassWord">
						<el-input v-model="ruleForm.PassWord" :disabled="isdisabled" show-password></el-input>
					</el-form-item>
				</el-form>
				<template #footer>
					<span class="dialog-footer">
						<el-button @click="editVisible = false">取 消</el-button>
						<el-button type="primary" @click="saveEdit('ruleForm')">确 定</el-button>
					</span>
				</template>
			</el-dialog>

		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	import qs from 'qs';
	export default {
		data() {
			return {
				isshow: true, //根据角色控制表头
				title: '',
				personList: [],
				ruleForm: [],
				personName: '', //角色名称
				token: localStorage.getItem('access_token'),
				roleid: '5d59a2fe-5f94-4671-8394-e2fefdb6d2ed',
				pageSize: 5,
				pageIndex: 1,
				pageTotal: '',
				name: '',
				editVisible: false,
				rules: {
					Name: [{
						required: true,
						message: '请输入角色名称',
						trigger: 'blur'
					}],
					RoleId: [{
						required: true,
						message: '请输入角色名',
						trigger: 'change'
					}],
					NickName: [{
						required: true,
						message: '请输入昵称',
						trigger: 'blur'
					}],
					Phone: [{
						required: true,
						message: '请输入手机号',
						trigger: 'blur'
					}, {
						pattern: /^1[0123456789]\d{9}$/,
						message: '目前只支持中国大陆的手机号码',
						trigger: "blur"
					}, {
						required: true,
						validator: this.bargainPhone,
						trigger: "blur"
					}],
					PassWord: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}],
					Age: [{
						required: true,
						message: '请输入年龄',
						trigger: 'blur'
					}],
					IdentityCard: [{
						required: true,
						message: '请输入身份证号',
						trigger: 'blur'
					}, {
						pattern: /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
						message: "目前只支持中国大陆的身份证号",
						trigger: "blur"
					}, {
						required: true,
						validator: this.bargainIdcard,
						trigger: "chang"
					}],
					Sex: [{
						required: true,
						message: '请输入性别',
						trigger: 'change'
					}],
					Region: [{
						required: true,
						message: '请输入区域',
						trigger: 'blur'
					}],
					Address: [{
						required: true,
						message: '请输入收货地址',
						trigger: 'blur'
					}],
					State: [{
						required: true,
						message: '请输入用户状态',
						trigger: 'change'
					}]
				},
				isdisabled: false,
				options: [], //select下拉切换角色
				value: '',
				userState: [{
					value: 0,
					name: '锁定'
				}, {
					value: 1,
					name: '正常'
				}]
			}
		},
		created() {
			if (this.roleid == '002860b9-6844-4982-9ac4-5453c9cdea3c' || this.roleid ==
				'a348ae2d-fb9c-4675-856c-936aa6c103c5' || this.roleid ==
				'2d7a48e5-503b-463e-878a-361e1b175551') {
				this.isshow = false
			} else {
				this.isshow = true
			}
			this.getData()
			this.getRoles()
		},
		methods: {

			start(row) {

				this.$confirm('确定打开用户权限, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'success'
				}).then(() => {

					this.ruleForm = row
					this.ruleForm.State = 1

					axios({
						method: 'post',
						url: this.$store.state.pcurl + "UpdateUser",
						data: qs.stringify(this.ruleForm),
						headers: {
							"Authorization": "bearer " + this.token
						},
					}).then((res) => {
						if (res.data.Message == '请求成功') {
							this.editVisible = false
							this.$message({
								message: '修改成功',
								type: 'success'
							})
							this.getData()
						} else {
							this.$message.error('修改失败');
						}
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消操作'
					});
				});

			},

			stop(row) {
				this.$confirm('确定关闭用户权限, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {

					this.ruleForm = row
					this.ruleForm.State = 0

					axios({
						method: 'post',
						url: this.$store.state.pcurl + "UpdateUser",
						data: qs.stringify(this.ruleForm),
						headers: {
							"Authorization": "bearer " + this.token
						},
					}).then((res) => {
						if (res.data.Message == '请求成功') {
							this.editVisible = false
							this.$message({
								message: '修改成功',
								type: 'success'
							})
							this.getData()
						} else {
							this.$message.error('修改失败');
						}
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消操作'
					});
				});
			},

			//删除用户
			deleteUser(row) {
				console.log(row)




				this.$confirm('此操作将删除该用户, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {


					axios({
						method: 'post',
						url: this.$store.state.url + "DeleteRole?roleId=" + row.Id,
						headers: {
							"Authorization": "bearer " + token + ""
						},
					}).then((res) => {
						console.log(res)
					})



					// this.$message({
					// 	type: 'success',
					// 	message: '删除成功!'
					// });
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});




			},
			//验证手机号
			bargainPhone(rule, value, callback) {
				if (this.title == '创建用户') {
					var token = this.token;
					axios({
						method: 'post',
						url: this.$store.state.url + "CheckPhone?Phone=" + value,
						headers: {
							"Authorization": "bearer " + token + ""
						},
					}).then((res) => {
						if (res.status == 200) {
							if (res.data.Data) {
								callback()
							} else {
								callback(new Error("该手机号已被添加"))
							}
						} else {
							callback(new Error("获取手机号信息失败"))
						}
					})
				} else if (this.title == '编辑') {
					var token = this.token;
					axios({
						method: 'post',
						url: this.$store.state.url + "CheckPhone?Phone=" + value + '&userId=' + this.ruleForm.Id,
						headers: {
							"Authorization": "bearer " + token + ""
						},
					}).then((res) => {
						if (res.status == 200) {
							if (res.data.Data) {
								callback()
							} else {
								callback(new Error("该手机号已被添加"))
							}
						} else {
							callback(new Error("获取手机号信息失败"))
						}
					})
				} else {
					callback()
				}

			},
			//验证身份证号
			bargainIdcard(rule, value, callback) {
				if (this.title == '创建用户') {
					var token = this.token;
					axios({
						method: 'post',
						url: this.$store.state.url + "CheckIdentityCard?IdentityCard=" + value,
						headers: {
							"Authorization": "bearer " + token + ""
						},
					}).then((res) => {
						if (res.status == 200) {
							if (res.data.Data) {
								callback()
							} else {
								callback(new Error("该身份证号已被添加"))
							}
						} else {
							callback(new Error("获取身份证信息失败"))
						}
					})
				} else if (this.title == '编辑') {
					var token = this.token;
					axios({
						method: 'post',
						url: this.$store.state.url + "CheckIdentityCard?IdentityCard=" + value + '&userId=' + this
							.ruleForm
							.Id,
						headers: {
							"Authorization": "bearer " + token + ""
						},
					}).then((res) => {
						if (res.status == 200) {
							if (res.data.Data) {
								callback()
							} else {
								callback(new Error("该身份证号已被添加"))
							}
						} else {
							callback(new Error("获取身份证信息失败"))
						}
					})
				} else {
					callback()
				}

			},
			//创建用户
			createPerson() {
				this.isdisabled = false
				this.ruleForm = []
				this.ruleForm.State = 1
				this.editVisible = true
				this.title = '创建用户'
			},
			changeUser(val) {
				console.log(val)
				this.roleid = val
				if (this.roleid == '002860b9-6844-4982-9ac4-5453c9cdea3c' || this.roleid ==
					'a348ae2d-fb9c-4675-856c-936aa6c103c5' || this.roleid ==
					'2d7a48e5-503b-463e-878a-361e1b175551') {
					this.isshow = false
				} else {
					this.isshow = true
				}
				this.getData()
			},
			//获取全部角色
			getRoles() {
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetRoles",
					headers: {
						Authorization: 'bearer ' + this.token
					}
				}).then((res) => {
					res.data.Data.forEach((x) => {
						if (x.Name != '会员') {
							this.options.push(x)
						}
					})
					this.options.forEach((x) => {
						if (x.Id == '5d59a2fe-5f94-4671-8394-e2fefdb6d2ed') {
							this.value = x.Name
						}
					})
				})
			},
			getData() {
				this.personList = []
				var pageIndex = this.pageIndex - 1
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetUsers?roleid=" + this.roleid +
						'&pageSize=' + this.pageSize + '&pageIndex=' + pageIndex + '&name=' + this
						.name,
					headers: {
						Authorization: 'bearer ' + this.token
					}
				}).then((res) => {
					this.pageTotal = res.data.Count
					if (res.data.Message == '请求成功') {
						res.data.Data.forEach((x) => {
							
							if (x.Id != '3fc1c573-54e1-4f89-a6df-cb4e8c276247') {
								this.personList.push(x)
							}else{
								this.pageTotal = res.data.Count - 1
							}

							x.AddTime = x.AddTime.replace('T', ' ')
							axios({
								method: 'get',
								url: this.$store.state.pcurl + "GetRoleModel?roleId=" + x.RoleId,
								headers: {
									Authorization: 'bearer ' + this.token
								}
							}).then((b) => {
								x.RoleName = b.data.Data.Name
							})
						})

					} else {
						this.$message.error('角色列表获取失败')
					}
				})
			},

			handleSearch() {
				this.name = this.personName
				this.pageIndex = 1
				this.getData()
			},
			handlePageChange(val) {
				this.pageIndex = val
				this.getData()
			},
			//查看
			handleClick(row) {
				console.log(row)
				this.title = '查看'
				this.isdisabled = true
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetUserModel?userId=" + row.Id,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					this.ruleForm = res.data.Data
					this.editVisible = true
				})
			},
			// 编辑
			handleEdit(index, row) {
				console.log(row)
				this.title = '编辑'
				this.isdisabled = false
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetUserModel?userId=" + row.Id,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					this.ruleForm = res.data.Data
					this.editVisible = true
				})
			},
			//保存编辑
			saveEdit(ruleForm) {
				if (this.title == '编辑') {
					this.$refs[ruleForm].validate((valid) => {
						if (valid) {
							axios({
								method: 'post',
								url: this.$store.state.pcurl + "UpdateUser",
								data: qs.stringify(this.ruleForm),
								headers: {
									"Authorization": "bearer " + this.token
								},
							}).then((res) => {
								if (res.data.Message == '请求成功') {
									this.editVisible = false
									this.$message({
										message: '修改成功',
										type: 'success'
									})
									this.getData()
								} else {
									this.$message.error('修改失败');
								}
							})
						} else {
							console.log('error submit!!');
							return false;
						}
					});
				} else if (this.title == '创建用户') {
					this.$refs[ruleForm].validate((valid) => {
						if (valid) {
							axios({
								method: 'post',
								url: this.$store.state.pcurl + "AddUser",
								data: qs.stringify(this.ruleForm),
								headers: {
									"Authorization": "bearer " + this.token
								},
							}).then((res) => {
								if (res.data.Message == '请求成功') {
									this.editVisible = false
									this.$message({
										message: '创建成功',
										type: 'success'
									})
									this.getData()
								} else {
									this.$message.error('创建失败');
								}
							})
						} else {
							console.log('error submit!!');
							return false;
						}
					});
				} else {
					this.editVisible = false
				}
			}
		}
	};
</script>

<style scoped>
	.el-select {
		width: 300px;
		margin-right: 10px;
	}

	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}
</style>
